
































import { Component, Prop, Vue, Emit, Mixins } from 'vue-property-decorator';
import { UserService } from '../../core/api';
import { NotificationStoreHelper } from '../../core/mixins';
@Component<FeedbackDialog>({})
export default class FeedbackDialog extends Mixins(NotificationStoreHelper) {
    @Prop() show: boolean;
    @Prop() companyId: number;
    rating: number = 0;
    comments: string = '';

    sayWho() {
        let ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { browser: 'IE', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            //if(tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            if (tem != null) return { browser: tem.slice(1)[0].replace('OPR', 'Opera'), version: tem.slice(1)[1] };
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return { browser: M[0], version: M[1] };
    }

    sendFeedback() {
        UserService.sendFeedback(this.rating * 2, this.comments, this.sayWho().browser, this.companyId)
            .then(() => {
                this.$_successSendFeedback('Enviado con éxito.');
            })
            .catch(() => {
                this.$_errorSendFeedback('Ha ocurrido un error enviando comentarios.');
            });

        this.cancelFeedback();
    }

    @Emit()
    cancelFeedback() {
        this.comments = '';
        this.rating = 0;
    }
}
